// This file can be replaced during build by using the `fileReplacements` array.
// When building for production, this file is replaced with `environment.prod.ts`.

export interface Environment {
  production: boolean;
  proxy: boolean;
  mixpanelToken: string;
  REACT_APP_URL: string;
  LEGACY_AUTH_ROOT?: string;
  REACT_APP_API: string;
  ACCOUNT_PORTAL_ROOT: string;
  WILSON_ACCOUNT_PORTAL_ROOT: string;
  ACCOUNT_PORTAL_BACKEND_ROOT: string;
  DASH_META_API: string;
  GO_API_ROOT: string;
  ORY_KRATOS_URL: string;
  COMPANY_MAPPER_URL: string;
  COMPANY_MAPPER_SNOWFLAKE_URL: string;
  OPEN_REPLAY_PROJECT_KEY: string;
  DOWNLOAD_DELIVERY_FILE_PREFIX: string;
  UNLEASH_CLIENT_KEY: string;
  UNLEASH_URL: string;
  RUPT_CLIENT_ID: string;
  SLOTS_API_KEY?: string;
  ZOHO_SALES_IQ_WIDGET_CODE: string;
  FIREBASE_API_KEY: string;
  FIREBASE_AUTH_DOMAIN: string;
  FIREBASE_PROJECT_ID: string;
  FIREBASE_STORAGE_BUCKET: string;
  FIREBASE_MESSAGING_SENDER_ID: string;
  FIREBASE_APP_ID: string;
  FIREBASE_MEASUREMENT_ID: string;
}

export const environment: Environment = {
  production: false,
  proxy: false,
  mixpanelToken: 'ec1f0aa55be261bfdd4532f606dcc86c',
  REACT_APP_URL: '',
  REACT_APP_API: '',
  ACCOUNT_PORTAL_ROOT: '',
  WILSON_ACCOUNT_PORTAL_ROOT: '',
  ACCOUNT_PORTAL_BACKEND_ROOT: '',
  DASH_META_API: '',
  GO_API_ROOT: '',
  ORY_KRATOS_URL: '',
  COMPANY_MAPPER_URL: '',
  COMPANY_MAPPER_SNOWFLAKE_URL: '',
  OPEN_REPLAY_PROJECT_KEY: 'pIcq54mQEQBu5QlixVFh',
  DOWNLOAD_DELIVERY_FILE_PREFIX: 'stage',
  UNLEASH_CLIENT_KEY:
    '*:development.2a8219f0ce918268f3c56ab1305d44e48dbfd06091910ef34f2c1fcc',
  UNLEASH_URL: 'https://us.app.unleash-hosted.com/usdd0003/api/frontend',
  RUPT_CLIENT_ID: '52a02c58-a84f-4627-ac07-f03415754e6b',
  SLOTS_API_KEY: 'iwveaelahjbtmvaokizrseemcwnoualx',
  ZOHO_SALES_IQ_WIDGET_CODE:
    'siq05ac96fd9a1d70fc6dd2f68e4e1011cd3bffeacb36747bb35f1aba29d4768893',
  FIREBASE_API_KEY: '',
  FIREBASE_AUTH_DOMAIN: '',
  FIREBASE_PROJECT_ID: '',
  FIREBASE_STORAGE_BUCKET: '',
  FIREBASE_MESSAGING_SENDER_ID: '',
  FIREBASE_APP_ID: '',
  FIREBASE_MEASUREMENT_ID: '',
};
